// extracted by mini-css-extract-plugin
export var productImage = "_r4-1";
export var viewLink = "_r4-2";
export var wishlistItem = "_r4-0";